module.exports = __webpack_public_path__ + "static/media/goals.c25caf49.svg";